import { ApplicationLayout } from "./application-layout";

import type { FC } from "react";

export const MomentFormLayout: FC = () => <ApplicationLayout />;
